import { defineMessages } from 'react-intl'

export const lang = defineMessages({
    title: {
        id: 'modal.3ds.question.title',
        defaultMessage: 'Security questions',
    },
    setup: {
        id: 'modal.3ds.question.setup',
        defaultMessage: 'Set up',
    },
    reset: {
        id: 'modal.3ds.question.reset',
        defaultMessage: 'Reset',
    },
    close: {
        id: 'modal.3ds.question.close',
        defaultMessage: 'Close',
    },
    continue: {
        id: 'modal.3ds.question.continue',
        defaultMessage: 'Continue',
    },
    successAlert: {
        id: 'modal.3ds.question.success_alert',
        defaultMessage: 'Your questions are already set up. But you can reset your questions and set them up again.',
    },
    warningAlert: {
        id: 'modal.3ds.question.warning_alert',
        defaultMessage: "You haven't set up the questions yet",
    },
    description: {
        id: 'modal.3ds.question.description',
        defaultMessage:
            "Answer a personal question you set up beforehand (e.g. your first teacher's name). No phone needed.",
    },
})
